<div fxLayout="column" fxFill fxLayoutAlign="start stretch">
  <!-- <app-header
    [title]="getToolbarTitle()"
  ></app-header> -->
  <!-- <div class="header">{{ getToolbarTitle() }}</div> -->

  <mat-drawer-container *ngIf="adminService.isAuthenticated()" class="example-container" fxFill class="drawer-container">
    <mat-drawer position="start" #drawer mode="side" opened class="drawer" style="border: 0;">
      <div fxLayout="column" fxLayoutAlign="space-between stretch" class="sidebar" fxFill>
        <div fxLayout="column" fxLayoutAlign="start stretch">
          <div class="sidebar-header">
            <img class="logo" src="assets/oer-logo-4.png" height="80" width="80" alt="Logo">
            <div class="header-title">{{ getToolbarTitle() }}</div>
            <!-- <div class="header-description">{{ adminService.user.displayName }}</div> -->
          </div>
          <div class="sidebar-nav">
            <div class="sidebar-nav-section">DASHBOARD</div>
            <button mat-button class="sidebar-nav-item" routerLinkActive="sidebar-nav-item-active" routerLink="/admin/users">
              <mat-icon>supervisor_account</mat-icon>
              <span>USERS</span>
            </button>
            <button mat-button class="sidebar-nav-item" routerLinkActive="sidebar-nav-item-active" routerLink="/admin/tasks">
              <mat-icon>assignment</mat-icon>
              <span>TASKS</span>
            </button>
            <button mat-button class="sidebar-nav-item" routerLinkActive="sidebar-nav-item-active" routerLink="/admin/feedbacks">
              <mat-icon>comment</mat-icon>
              <span>FEEDBACKS</span>
            </button>
          </div>
        </div>
        <div fxLayout="column" fxLayoutAlign="start stretch" class="sidebar-footer">
          <button mat-button class="sidebar-footer-item" routerLink="/">
            <span class="sidebar-footer-item-text" i18n>Main Tool</span>
            <mat-icon>fast_rewind</mat-icon>
          </button>
          <!-- <button mat-button class="sidebar-footer-item" routerLink="/" i18n>Go back to main tool</button> -->
          <button mat-button class="sidebar-footer-item" (click)="adminService.logout()">
            <span class="sidebar-footer-item-text">{{ adminService.user.displayName }}</span>
            <mat-icon>logout</mat-icon>
          </button>
        </div>
      </div>
    </mat-drawer>
    <mat-drawer-content>
      <div class="main-content" fxLayout="column" fxFill fxLayoutAlign="start stretch">
        <mat-toolbar class="mat-elevation-z8">
          <div class="main-content-toolbar">
            <button mat-icon-button>
              <mat-icon>menu</mat-icon>
            </button>
            <!-- <button mat-icon-button (click)="drawer.toggle()">
              <mat-icon>menu</mat-icon>
            </button> -->
            Admin Dashboard
          </div>
        </mat-toolbar>
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>

  <div *ngIf="!adminService.isAuthenticated()" class="centerButton">
    <h1 class="title">Admin Area</h1>
    <div class="centerButton">
      <button mat-stroked-button routerLink="/" i18n>Go back to main tool</button>
    </div>
    <h3>You are currently not authenticated. Please login with GitLab to continue.</h3>
    <a mat-raised-button color="primary" [href]="getAuthURL()">Authenticate with GitLab</a>
    <br />
  </div>

</div>